export default "__VITE_ASSET__8RiihekJ__"